import React from 'react';
import { Box, Button, Divider, Stack } from '@mui/material';
import { AutoComplete } from './AutoComplete';
import { useUserFilterActions } from '../../hooks/useUserFilterActions';
import { useFilterContext } from '../context/FilterContext';
import { FieldControl } from './FieldControl';

interface FilterSideBarProps {
    hiddenFilters?: Array<'region' | 'workstream' | 'programme' | 'site'>;
    onClose?: () => void;
};

export const FilterSideBar: React.FC<FilterSideBarProps> = ({ hiddenFilters = [], onClose }) => {

    const { tempFilters, handleUpdateTempFilters, handleApplyFilters, handleResetFilters } = useFilterContext();
    const { userFilterActions, getFilteredData, cleanFilters } = useUserFilterActions();

    const safeArray = (arr: string[]) => arr.map(Number);

    const { regions, workstreams } = getFilteredData({
        regionIds: safeArray(tempFilters.region)
    });

    const handleChange = (
        key: 'region' | 'workstream',
        value: string[]
    ) => {
        const updated = { ...tempFilters, [key]: value };
        const cleaned = cleanFilters(updated, key, userFilterActions);
        Object.entries(cleaned).forEach(([k, v]) => {
            handleUpdateTempFilters(k as keyof typeof tempFilters, v as string[]);
        });
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Box flexGrow={1} sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
                {!hiddenFilters?.includes('site') && (
                    <AutoComplete
                        value={tempFilters.site}
                        onSelect={(value) => handleUpdateTempFilters('site', value)}
                        name="site"
                        label="Site"
                    />
                )}
                {!hiddenFilters?.includes('programme') && (
                    <AutoComplete
                        value={tempFilters.programme}
                        onSelect={(value) => handleUpdateTempFilters('programme', value)}
                        name="programme"
                        label="Programme"
                    />
                )}
                {!hiddenFilters.includes('region') && (
                    <FieldControl
                        keyName={'region'}
                        label={'Network'}
                        variant={'select'}
                        options={regions.map((r: any) => {
                            return { value: String(r.id), label: r.name };
                        })}
                        value={tempFilters.region}
                        onChange={(_key: string, value: string[]) => handleChange('region', value)}
                        multiSelect
                    />
                )}
                {!hiddenFilters.includes('workstream') && (
                    <FieldControl
                        keyName={'workstream'}
                        label={'Workstream'}
                        variant={'select'}
                        options={workstreams.map((r: any) => {
                            return { value: String(r.id), label: r.name };
                        })}
                        value={tempFilters.workstream}
                        onChange={(_key: string, value: string[]) => handleChange('workstream', value)}
                        multiSelect
                    />
                )}
            </Box>
            <Stack direction="row" spacing={2} justifyContent="flex-end" flexShrink={0} bgcolor={'action.hover'} p={2}>
                <Button variant='outlined' onClick={() => { handleResetFilters() }}>Reset</Button>
                <Button variant='contained' onClick={() => {
                    handleApplyFilters();
                    onClose?.();
                }}>Apply</Button>
            </Stack>
        </Box>
    );
};